import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/';

import { Experience, Education, Languages, Skills, Project } from '../interfaces/interfaces';

@Injectable()
export class ResumeService {

  constructor(
    private http: HttpClient
  ) { }
  getResumeById(id): Observable<any> {
    return this.http.get(
      `/my/resume/${id}`,
      {}
    );
  }
  getAllResume(): Observable<any> {
    return this.http.get(
      `/my/resume`,
      {}
    );
  }
  editResume(data: any): Observable<any> {
    return this.http.patch(
      `/resume`,
      data,
      {}
    );
  }
  addOptional(data: any): Observable<any> {
    return this.http.post(
      `/optional`,
      data,
      {}
    );
  }
  editOptional(data: any): Observable<any> {
    return this.http.patch(
      `/optional`,
      data,
      {}
    );
  }
  updateExperience(experience: Experience): Observable<any> {
    return this.http.patch(
      `/experience`,
      experience,
      {}
    );
  }
  updateEducation(education: Education): Observable<any> {
    return this.http.patch(
      `/education`,
      education,
      {}
    );
  }
  updateLanguage(languages: Languages): Observable<any> {
    return this.http.patch(
      `/languages`,
      languages,
      {}
    );
  }
  updateSkill(skills: Skills): Observable<any> {
    return this.http.patch(
      `/skills`,
      skills,
      {}
    );
  }
  updateProject(project: Project): Observable<any> {
    return this.http.patch(
      `/project`,
      project,
      {}
    );
  }
  generateResume(data: any): Observable<any> {
    const header: HttpHeaders = new HttpHeaders({'Content-Type': 'text/html'});
    return this.http.post(
      `/resume/pdf`,
      data,
      {}
    );
  }
}
